import { Button, Checkbox, Flex, Form, Spacing, StepperLines, Text } from '@approvalmax/ui/src/components';
import React, { memo } from 'react';
import { SsoPanel } from 'shared/components';

import { fields } from '../../constants';
import { FormSectionAccountInfo } from '../FormSectionAccountInfo/FormSectionAccountInfo';
import { FormSectionFooter } from '../FormSectionFooter/FormSectionFooter';
import { FormSectionQualificationQuestions } from '../FormSectionQualificationQuestions/FormSectionQualificationQuestions';
import { useProfileSetupForm } from './ProfileSetupForm.hooks';
import { messages } from './ProfileSetupForm.messages';
import { ProfileSetupFormProps } from './ProfileSetupForm.types';

export const ProfileSetupForm = memo<ProfileSetupFormProps>((props) => {
    const {
        email,
        isLoading,
        profileData,
        showPhoneField,
        showConsent,
        showQuestions,
        showPasswordField,
        showSsoPanel,
        showProgress,
        onSubmit,
        ...otherProps
    } = props;

    const { form, onFormSubmit } = useProfileSetupForm(props);

    return (
        <>
            <Form form={form} onSubmit={onFormSubmit}>
                <Flex direction='column' spacing='24' {...otherProps}>
                    {showProgress && <StepperLines stepsCount={3} currentStep={2} />}

                    <Text font='headline' fontSize='small' fontWeight='regular' textAlign='center'>
                        {messages.profileSetupTitle}
                    </Text>

                    <FormSectionAccountInfo showPhoneField={showPhoneField} showPasswordField={showPasswordField} />

                    {showQuestions && <FormSectionQualificationQuestions />}

                    <Flex spacing='16' direction='column'>
                        {showConsent && (
                            <Checkbox name={fields.fieldNameConsentMarketingAccepted} size='small' alignItems='center'>
                                <Text font='label' fontSize='small' fontWeight='regular' spacing='0'>
                                    {messages.consentMarketingText}
                                </Text>
                            </Checkbox>
                        )}

                        <Button size='large' type='submit' block progress={isLoading} disabled={isLoading}>
                            {messages.signupButtonText}
                        </Button>
                    </Flex>

                    {showConsent && <FormSectionFooter />}
                </Flex>
            </Form>

            <Spacing height={24} />

            {showSsoPanel && (
                <SsoPanel
                    variant='register'
                    disabled={isLoading}
                    allowedEmail={email}
                    afterLoginRedirectUrl={window.location.href}
                    afterSignUpRedirectUrl={window.location.href}
                />
            )}
        </>
    );
});

ProfileSetupForm.displayName = 'ProfileSetupForm';
